import { Trash2 } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle,
} from "components/ui/alert-dialog";

// Controlled dialog: rendered once at the SaveFiltersSelect level and driven by
// the row that was clicked, so it lives outside the combobox popup and survives
// the popup closing.
export function DeleteSavedFilterDialog({
  filter,
  open,
  onOpenChange,
  onConfirm,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent size="sm">
        <AlertDialogHeader>
          <AlertDialogMedia className="tw:bg-destructive/10 tw:text-destructive tw:dark:bg-destructive/20 tw:dark:text-destructive">
            <Trash2 />
          </AlertDialogMedia>
          <AlertDialogTitle as="span">Delete filter?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently delete
            {filter?.name ? ` "${filter.name}"` : " this filter"}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel variant="outline">Cancel</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={() => onConfirm?.(filter)}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
